import { Component, OnInit } from '@angular/core';
import { Management } from '../gcg/gcg.component';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss'],
})
export class ManagementComponent implements OnInit {
  divisions: Management[] = [
    {
      division_name: 'COMPANY.GCG.AUDIT_COMMITTEE',
      members: [
        {
          name: 'Leonardus Chrisbiantoro',
          position: 'COMPANY.GCG.CHAIRMAN',
        },
        {
          name: 'Mohamad Mahfudin',
          position: 'COMPANY.GCG.MEMBER',
        },
        {
          name: 'Dwi Putri Kemuning',
          position: 'COMPANY.GCG.MEMBER',
        },
        // {
        //   name: 'Raihan Nabil Zakiy',
        //   position: 'COMPANY.GCG.CHAIRMAN',
        // },
        // {
        //   name: 'Ibnu Haritsah',
        //   position: 'COMPANY.GCG.MEMBER',
        // },
        // {
        //   name: 'Dwi Susetio',
        //   position: 'COMPANY.GCG.MEMBER',
        // },
      ],
      documents: [
        {
          name: 'COMPANY.GCG.AUDIT_COMMITTEE_CHARTER',
          url: 'PIAGAM_KOMITE_AUDIT.pdf',
        },
        {
          name: 'COMPANY.GCG.APPROVAL_BOARD_OF_COMMISSIONERS_REGARDING_THE_AUDIT_COMMITTEE',
          url: 'Persetujuan_Dewan_Komisaris_terkait_Komite_Audit_IJE_.pdf',
        },
      ],
    },
    {
      division_name: 'COMPANY.GCG.CORPORATE_SECRETARY',
      members: [
        {
          name: 'Veronika Hana Girsang',
          position: 'COMPANY.GCG.CORPORATE_SECRETARY',
          profile_picture: 'pp_vero.png',
        },
      ],
      documents: [
        {
          name: 'COMPANY.GCG.CORPORATE_SECRETARY_CHANGE',
          url: 'IJEE-Penggantian_Sekretaris_Perusahaan.pdf',
        },
        {
          name: 'COMPANY.GCG.CORPORATE_SECRETARY_APPOINTMENT',
          url: 'IJEE-Surat_Penunjukan_Corsec_PT_IJE.pdf',
        },
        {
          name: 'COMPANY.GCG.CORPORATE_SECRETARY_RESIGN',
          url: '270924-Liza-IJE -Surat_Pengunduran_Diri_Sekretaris_Perusahaan.pdf',
        },
      ],
    },
    {
      division_name: 'COMPANY.GCG.INTERNAL_AUDIT',
      members: [],
      documents: [
        // {
        //   name: 'COMPANY.GCG.INTERNAL_AUDIT_CHARTER',
        //   url: 'PIAGAM_AUDIT_INTERNAL.pdf',
        // },
        // {
        //   name: 'COMPANY.GCG.INTERNAL_AUDIT_APPOINTMENT',
        //   url: 'Surat_Pernyataan_Perseroan_-_Obligasi_-_IJE_R.pdf',
        // },
        {
          name: 'Penunjukan dan Penangkatan Kepala Unit Audit Internal',
          url: '28.02.2025 SK Penunjukan dan Pengangkatan Kepala Unit Audit Internal IJE.pdf',
        },
      ],
    },
    {
      division_name: 'COMPANY.GCG.NOMINATION_AND_REMUNERATION',
      members: [],
      documents: [
        {
          name: 'COMPANY.GCG.RENUMERATION_GUIDE',
          url: 'PEDOMAN_REMUNERASI_IJE.pdf',
        },
      ],
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
